import { useCallback } from 'react';
import {
  AccessTime as AccessTimeIcon,
  Event as EventIcon,
} from '@material-ui/icons';

import { IconButton, makeStyles } from '@lsy-netline-ui/netline-ui';

import { useDomain, useMultiColumn } from '../../../hooks';
import { MODULE_CHOICE_POPUP_EVENT, PemsDomain } from '../../../consts';
import ModuleAvatar from './ModuleAvatar';

const useStyles = makeStyles(() => ({
  moduleAvatarButton: {
    padding: '9px',
  },
}));

const ModuleSwitchButton = () => {
  const { pemsDomain } = useDomain();
  const classes = useStyles();
  const multiColumn = useMultiColumn();

  const switchModule = useCallback(() => {
    window.dispatchEvent(new Event(MODULE_CHOICE_POPUP_EVENT));
  }, []);

  if (multiColumn) {
    return null;
  }
  return (
    <IconButton onClick={switchModule} className={classes.moduleAvatarButton} size="small">
      <ModuleAvatar>
        {pemsDomain === PemsDomain.IADP ? <EventIcon /> : <AccessTimeIcon />}
      </ModuleAvatar>
    </IconButton>
  );
};

export default ModuleSwitchButton;
